export default __webpack_public_path__ + "static/media/logo_side.dd814eca.png";